import type React from "react";
import { createContext, type Dispatch, type ReactNode } from "react";
import { useLocalStorage } from "usehooks-ts";
import type { Hierachy } from "../hooks/useHierarchyData";
import type { ColorSearchSettings } from "../models/colors";

export const defaultSettings: ColorSearchSettings = {
  externalViewVisible: false,
  colorMaterialVisible: true,
  availabilityVisible: true,
  colorSpecificationsVisible: true,
  opticalMaterialDataVisible: true,
  customerOemVisible: true,
  competitorVisible: true,
  digitalSampleVisible: true,
  language: "EN",
  yearOfDevelopment: "",
  preliminaryColorCode: [],
  brand: [],
  cdc: [],
  inputTypingSearch: false,
  materialSection: "materialGrade",
  dataset: "original",
};

export interface SettingsContextValue {
  settings: ColorSearchSettings;
  setSettings: Dispatch<ColorSearchSettings>;
  hierachyData: Hierachy[];
}

export const SettingsContext = createContext<SettingsContextValue>({
  settings: defaultSettings,
  setSettings: () => undefined,
  hierachyData: [
    {
      industry: "",
      description: "",
      applicationClass: [
        {
          class: "",
          application: [
            {
              application: "",
              grade: [],
            },
          ],
        },
      ],
    },
  ],
});

interface SettingsProviderProps {
  children: ReactNode;
  hierachyData: Hierachy[];
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({
  children,
  hierachyData,
}) => {
  const [settings, setSettings] = useLocalStorage(
    "search-settings",
    defaultSettings,
  );

  return (
    <SettingsContext.Provider value={{ settings, setSettings, hierachyData }}>
      {children}
    </SettingsContext.Provider>
  );
};
